"use client";
import Picture1 from "../images/top-recommended/ba-na-cable-car.webp";
import Picture2 from "../images/top-recommended/ba-na-hills.webp";
import Picture3 from "../images/top-recommended/cam-thanh-coconut-village.webp";
import Picture4 from "../images/top-recommended/gam-ghi-island.webp";
import Picture5 from "../images/top-recommended/golden-bridge.webp";
import Picture6 from "../images/top-recommended/grand-world-phu-quoc.webp";
import Picture7 from "../images/top-recommended/hon-thom-cable-car.webp";
import Picture8 from "../images/top-recommended/chinese-assembly-halls.webp";
import Picture9 from "../images/top-recommended/huyen-khong.webp";
import Picture10 from "../images/top-recommended/japanese-bridge-in-hoi-an.webp";


import PaginationLeft from "@/public/svg/paginarition-arrow-left.svg";
import PaginationRight from "@/public/svg/paginarition-arrow-right.svg";

import Heading from "@/components/heading/heading";

import Image from "next/image";

import "@/styles/common/typo.scss";
import "@/sections/common/top-recommended/top-recommended.scss";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import { Navigation } from "swiper/modules";

const TopRecommendedList = [
    {
        name: "Ba Na Cable Car",
        picture: Picture1,
        location: "",
    },
    {
        name: "Ba Na Hills",
        picture: Picture2,
        location: "",
    },
    {
        name: "Cam Thanh Coconut Village",
        picture: Picture3,
        location: "",
    },
    {
        name: "Gam Ghi Island",
        picture: Picture4,
        location: "",
    },
    {
        name: "Golden Bridge",
        picture: Picture5,
        location: "",
    },
    {
        name: "Grand World Phú Quốc",
        picture: Picture6,
        location: "",
    },
    {
        name: "Hon Thom Cable Car",
        picture: Picture7,
        location: "",
    },
    {
        name: "Chinese Assembly Halls",
        picture: Picture8,
        location: "",
    },
    {
        name: "Huyền Không",
        picture: Picture9,
        location: "",
    },
    {
        name: "Japanese Bridge In Hoi An",
        picture: Picture10,
        location: "",
    },
];

const TopRecommended = () => {
    return (
        <section className="top-recommended-section flex items-center py-10 md:py-20 gap-6">
            <div className="top-recommended-info flex flex-col gap-4 container-start">
                <div className="form-title flex flex-col">
                    <Heading as="h3" className="font-yesteryear font-extralight">
                        Top Recommended
                    </Heading>
                    <Heading as="h2" className="text-white">
                        Must Do Things
                    </Heading>
                </div>
                <p className="lead">
                Discover rich cultures, indulge in local cuisines, and explore breathtaking landscapes.
                </p>
                <div className="swiper-pagination-wrapper flex items-center gap-2 mt-2">
                    <div className="pagination-arrows flex items-center gap-3 sm:gap-4">
                        <figure className="pagination-left-top-recommended flex-center">
                            <Image loading="lazy"
                                src={PaginationLeft}
                                alt="Pagination Left"
                                
                            />
                        </figure>
                        <figure className="pagination-right-top-recommended flex-center">
                            <Image loading="lazy"
                                src={PaginationRight}
                                alt="Pagination Right"
                                
                            />
                        </figure>
                    </div>
                </div>
            </div>
            <div className="top-recommended-slider pl-4">
                <Swiper
                    spaceBetween={16}
                    slidesPerView={1}
                    navigation={{
                        nextEl: ".pagination-right-top-recommended",
                        prevEl: ".pagination-left-top-recommended",
                        enabled: true,
                    }}
                    modules={[Navigation]}
                    breakpoints={{
                        480: {
                            slidesPerView: 2,
                        },
                        767: {
                            slidesPerView: 3,
                        },
                        1023: {
                            slidesPerView: 2,
                        },
                        1279: {
                            slidesPerView: 3,
                        },
                        1535: {
                            slidesPerView: 4,
                        },
                    }}
                    className="top-recommended-swiper"
                >
                    {TopRecommendedList.map((t, index) => {
                        return (
                            <SwiperSlide
                                key={index}
                                className="top-recommended-slide"
                            >
                                <a
                                    
                                    className="inline-flex flex-col gap-6"
                                >
                                    <figure>
                                        <Image loading="lazy"
                                            src={t.picture}
                                            alt={t.name}
                                            
                                        />
                                        <figcaption className="flex flex-col items-start justify-end p-4">
                                            <Heading
                                                as="h6"
                                                className="text-white"
                                            >
                                                {t.name}
                                            </Heading>
                                            <span className="font-light text-white">
                                                {t.location}
                                            </span>
                                        </figcaption>
                                    </figure>
                                </a>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>
        </section>
    );
};

export default TopRecommended;
